import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import aboutUsImage from "../images/gallery/Van2.jpg";

const AboutUs: React.FC = () => {
  return (
    <section className="py-5 text-white">
      <Container>
        {/* Heading */}
        <Row className="mb-4">
          <Col lg={10}>
            <h1 className="fw-bold mb-2">About Us</h1>
            <p className="text-white-75 mb-0">
              Wood-fired dough, quality ingredients, and the charm of classic Citroën HY vans.
            </p>
          </Col>
        </Row>

        <Row className="align-items-stretch g-4">
          {/* Left: glass content */}
          <Col md={6}>
            <Card className="h-100 shadow-sm bg-custom-dark text-white border-secondary rounded-4">
              <Card.Body className="p-4">
                <p>
                  At <strong>Bartollini Pizza</strong>, everything starts with quality ingredients and a genuine
                  love for Italian cooking. We work closely with local suppliers wherever possible, combining
                  fresh Irish produce with traditional Italian techniques to the best, wood-fired pizza.
                </p>

                <p>
                  Pizza is more than just food for us — it’s a passion developed from a young age. With over 20 
                  years of hands-on experience, Bartollini has spent decades learning, refining, and perfecting 
                  the craft of pizza making. Italian cooking has always been a central part of his life, with 
                  pizza becoming a second love that naturally grew into a full-time pursuit.
                </p>

                <p className="mb-3">
                  What began as a personal passion has grown into Bartollini Pizza — serving events, private bookings, 
                  and customers across Galway and beyond. Whether it’s a wedding, birthday, corporate event, or 
                  festival, the focus remains the same: great food, made properly, and served with care.
                </p>

                {/* Why HY callout */}
                <div className="ps-3 border-start border-3 border-warning mb-3">
                  <h2 className="h5 fw-semibold mb-1">Why a Citroën HY?</h2>
                  <p>
                    Our pizza vans are classic Citroën HY vehicles, imported directly from the heart of France. 
                    These iconic vans have a rich history — many were originally used as fire trucks and service 
                    vehicles, built to be tough, reliable, and functional.
                  </p>

                  <p>
                    Each van has been fully restored from scratch, carefully converted into a mobile pizzeria. 
                    Behind the vintage look, you’ll find modern wood-fired ovens and a fully equipped prep 
                    space — blending old-school character with modern standards.
                  </p>

                  <p className="mb-0 text-white-75">
                    The result is something unique: authentic wood-fired pizza, served from vehicles with real history and personality.
                  </p>
                </div>

                <ul className="list-unstyled mb-4">
                  <li className="mb-2">🍕 Authentic wood-fired pizzas, cooked at high heat</li>
                  <li className="mb-2">🚐 Classic Citroën HY vans for mobile catering</li>
                  <li className="mb-2">🌿 Quality ingredients from trusted suppliers</li>
                  <li className="mb-2">🎉 Custom menus for private & corporate events</li>
                  <li className="mb-2">❤️ Friendly, professional team</li>
                </ul>

                <div className="d-flex flex-wrap gap-3">
                  <Link to="/book-event" className="btn btn-outline-warning">
                    Book an Event
                  </Link>
                  <Link to="/gallery" className="btn btn-outline-light">
                    See the Vans
                  </Link>
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* Right: image only (no glass) */}
          <Col md={6} className="d-flex align-items-center justify-content-center">
            <figure className="m-0 text-center">
              <div className="rounded-4 overflow-hidden shadow-lg">
                <img
                  src={aboutUsImage}
                  alt="Bartollini Pizza Citroën HY van"
                  className="img-fluid rounded-4 shadow-lg"
                  loading="lazy"
                />
              </div>
              <figcaption className="mt-2 small text-white-75">
                The pizza master himself in one of our iconic Citroën HY vans
              </figcaption>
            </figure>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AboutUs;
